import { css } from 'linaria';
import { styled } from 'linaria/react';
import { sendEvent } from 'model/helpers/events.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { h } from 'preact';

import { FallbackLayout } from 'features/fallback/ui/fallback-layout';
import { useEffect } from 'preact/hooks';
import { Spinner } from 'ui/spinner';
import { Subtitle, Text } from 'ui/typography';
import { InfoIcon } from 'ui/icons/info-icon';
import { Container } from 'ui/container';

export const PhoneConnectedView = () => {
	const t = useLocalization();

	useEffect(() => {
		screenHistoryPush(ScreenName.mobile_connected);
		setTimeout(() => {
			sendEvent({ event: 'mobile_connected_screen_shown' });
		}, 20)
	}, []);

	return (
		<FallbackLayout>
			<Subtitle style={{ textAlign: 'center', marginTop: 30 }}>
				{t('flow.bridge.title')}
			</Subtitle>
			<Spinner
				size={48}
				fill={{
					primary: 'var(--primary-color)',
					secondary: 'var(--secondary-color)'
				}}
				className={spinner}
			/>
			<Container>
				<InfoBlock>
					<IconContainer>
						<InfoIcon fill={'var(--text-tertiary)'}/>
					</IconContainer>
					<Items>
						<Text>{t('flow.bridge.hint.1')}</Text>
						<Text>{t('flow.bridge.hint.2')}</Text>
						<Text>{t('flow.bridge.hint.3')}</Text>
					</Items>
				</InfoBlock>
			</Container>
		</FallbackLayout>
	);
};

const Items = styled('div')`
	& > * {
		margin-bottom: 8px;
		
		&:last-child {
			margin-bottom: 0;
		}
	}
`;
const IconContainer = styled('div')`
	display: flex;
	align-items: center;
	height: 22px;
`;
const InfoBlock = styled('div')`
	display: flex;
	padding: 12px;
	margin-top: auto;
	margin-bottom: 30px;
	border: 1px solid var(--button-outline-border);
	border-radius: 4px;
	
	svg {
		margin-right: 9px;
	}
`;
const spinner = css`
	margin: 48px auto 0;
`;

